import Seo from "../components/Seo";

export default function PrivacyPolicyPage() {
  const title = "นโยบายความเป็นส่วนตัว";

  return (
    <>
      <Seo title={title} description="รายละเอียดการเก็บ ใช้ เปิดเผย และดูแลข้อมูลส่วนบุคคล รวมถึงสิทธิและช่องทางติดต่อ KMCP Accounting" path="/privacy" />
      <section className="mx-auto max-w-4xl px-6 py-20 sm:px-8">
        <h1 className="text-4xl font-semibold text-gray-900">นโยบายความเป็นส่วนตัว</h1>
        <p className="mt-4 text-sm text-gray-500">อัปเดตล่าสุด: พฤศจิกายน 2568</p>
        <div className="mt-10 space-y-10 text-base leading-relaxed text-gray-700">
          <section>
            <h2 className="text-2xl font-semibold text-gray-900">1. ขอบเขตการบังคับใช้</h2>
            <p className="mt-3">
              นโยบายฉบับนี้ครอบคลุมการเก็บรวบรวม ใช้ เปิดเผย และการปกป้องข้อมูลส่วนบุคคลทั้งหมดที่ KMCP Accounting ได้รับผ่านเว็บไซต์หลัก
              ฟอร์มติดต่อ ระบบรับเอกสารดิจิทัล รวมถึงช่องทาง LINE Official และอีเมลบริการลูกค้า
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">2. ประเภทข้อมูลที่รวบรวม</h2>
            <ul className="mt-3 list-disc space-y-2 pl-6 text-gray-700">
              <li>ข้อมูลติดต่อ เช่น ชื่อ นามสกุล เบอร์โทร อีเมล และ Line ID</li>
              <li>ข้อมูลธุรกิจ เช่น ชื่อบริษัท เลขประจำตัวผู้เสียภาษี ประเภทธุรกิจ ปริมาณเอกสารทางบัญชี</li>
              <li>ข้อมูลการใช้งานเว็บไซต์ เช่น IP address, browser, session log สำหรับการวิเคราะห์ประสบการณ์ผู้ใช้</li>
              <li>เอกสารประกอบบริการบัญชี ภาษี และเงินเดือน ที่ลูกค้ามอบหมายเข้ามายังระบบของเรา</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">3. วัตถุประสงค์การใช้ข้อมูล</h2>
            <p className="mt-3">
              เราใช้ข้อมูลส่วนบุคคลเท่าที่จำเป็นเพื่อให้บริการบัญชีและภาษี ดำเนินสัญญาว่าจ้าง แจ้งเตือนกำหนดภาษี
              ส่งมอบรายงาน วิเคราะห์พัฒนาการบริการ และสื่อสารข่าวสารที่เกี่ยวข้องกับบริการของ KMCP Accounting เท่านั้น
            </p>
            <p className="mt-3">
              หากมีความจำเป็นต้องใช้ข้อมูลเพื่อวัตถุประสงค์อื่น เราจะขอความยินยอมเพิ่มเติมก่อนทุกครั้ง
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">4. การเก็บรักษาและความปลอดภัย</h2>
            <p className="mt-3">
              เราใช้มาตรการด้านองค์กรและเทคนิคตามความเหมาะสมกับประเภทข้อมูล จำกัดการเข้าถึงเฉพาะผู้ที่เกี่ยวข้องกับการให้บริการ และทบทวนสิทธิ์เมื่อไม่มีความจำเป็นต้องใช้งาน
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">5. การเปิดเผยข้อมูล</h2>
            <p className="mt-3">
              เราไม่ขาย แลกเปลี่ยน หรือเปิดเผยข้อมูลส่วนบุคคลให้บุคคลภายนอก ยกเว้นกรณีต่อไปนี้
            </p>
            <ul className="mt-3 list-disc space-y-2 pl-6 text-gray-700">
              <li>ได้รับความยินยอมจากเจ้าของข้อมูลอย่างชัดเจน</li>
              <li>ต้องเปิดเผยตามข้อกำหนดของกฎหมาย หน่วยงานกำกับดูแล หรือคำสั่งศาล</li>
              <li>ใช้ผู้ให้บริการระบบที่จำเป็นต่อการดำเนินงาน โดยจำกัดข้อมูลตามวัตถุประสงค์ของบริการ</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">6. สิทธิของเจ้าของข้อมูล</h2>
            <p className="mt-3">
              ลูกค้าสามารถร้องขอให้เข้าถึง คัดลอก แก้ไข ระงับการใช้ หรือขอลบข้อมูลของตนได้ รวมถึงคัดค้านการประมวลผล
              โดยติดต่อทีมงานผ่านช่องทางที่ระบุด้านล่าง เราจะตรวจสอบคำขอและดำเนินการตามกรอบเวลาที่กฎหมายกำหนด
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">7. ระยะเวลาเก็บข้อมูล</h2>
            <p className="mt-3">
              KMCP Accounting จะเก็บข้อมูลตามระยะเวลาที่จำเป็นต่อการให้บริการและเป็นไปตามข้อกำหนดของกฎหมายภาษีและบัญชี
              เมื่อพ้นความจำเป็น เราจะลบหรือทำให้ข้อมูลไม่สามารถระบุตัวตนได้ตามมาตรฐานสากล
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">8. คุกกี้และเครื่องมือวิเคราะห์</h2>
            <p className="mt-3">
              เว็บไซต์อาจใช้คุกกี้เชิงวิเคราะห์ Google Analytics หรือเครื่องมือภายในเพื่อวัดผลการใช้งาน
              ข้อมูลที่เก็บเป็นข้อมูลสถิติไม่สามารถระบุตัวบุคคล หากต้องการปิดใช้งานสามารถเปลี่ยนการตั้งค่าบราวเซอร์ได้ตลอดเวลา
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">9. การปรับปรุงนโยบาย</h2>
            <p className="mt-3">
              เราอาจปรับปรุงนโยบายนี้เป็นระยะเพื่อให้สอดคล้องกับกฎหมายและมาตรฐานความปลอดภัยล่าสุด
              จะแจ้งวันที่มีผลบังคับใช้ที่ส่วนต้นของเอกสารทุกครั้ง
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-gray-900">10. ช่องทางติดต่อ</h2>
            <p className="mt-3">
              หากมีคำถามหรือขอใช้สิทธิภายใต้ PDPA ติดต่อได้ที่อีเมล{" "}
              <a href="mailto:kmcp.acc@gmail.com" className="text-brand underline">
                kmcp.acc@gmail.com
              </a>{" "}
              หรือจดหมายถึงทีมคุ้มครองข้อมูล KMCP Accounting
            </p>
          </section>
        </div>
      </section>
    </>
  );
}
